import { themeOptions } from "./types";

export const activePathThemes: themeOptions = {
	success: 'var(--epods--color-signal-success-icon)',
	warning: 'var(--epods--color-signal-warning-icon)',
	error: 'var(--epods--color-signal-error-icon)',
	default: 'var(--epods--color-bg-primary)',
	inherit: 'var(--epods--color-text-inverted)',
};

export const presetSizes = {
	small: '14px',
	medium: '32px',
	large: '40px',
};

export const presetBorderSizes = {
	small: '2px',
	medium: '4px',
	large: '6px',
};

export const spinnerContainerStyle = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	width: 'fit-content',
};

export const loadingLabelStyle = {
	color: 'var(--epods--color-text-primary)',
	fontSize: '18px',
	lineHeight: '26px',
	marginTop: '18px',
};